const GOOGLE_MAP_API_KEY = "AIzaSyC2UTxz6yQp_ZsIaJoVNjYBCmSX7k5th6g"
export default GOOGLE_MAP_API_KEY;